import clsx from "clsx";

const StatsCard = ({
  title,
  value,
  subtitle = "",
  icon = null,
  className = "",
}) => {
  return (
    <div className={clsx("content-card p-5", className)}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-muted-warm">{title}</p>
          <p className="mt-2 text-3xl font-semibold text-henna">{value}</p>

          {subtitle ? (
            <p className="mt-2 text-sm leading-6 text-muted-warm">{subtitle}</p>
          ) : null}
        </div>

        {icon ? (
          <div className="rounded-2xl bg-soft-cream p-3 text-henna">{icon}</div>
        ) : null}
      </div>
    </div>
  );
};

export default StatsCard;